import React, { useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import Footer from "./Components/common/Footer";
import Header from "./Components/common/Header";
import CustomRoutes from "./router/CustomRoutes";
import { useTranslation } from "react-i18next";
/* import TopBar from "./Components/common/TopBar"; */
import SimpleReactLightbox from 'simple-react-lightbox';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const userLanguage = navigator.language || navigator.userLanguage;
    if (userLanguage.includes("tr")) {
      i18n.changeLanguage("tr"); // Tarayıcı dilini Türkçe olarak algıladığında dil ayarınızı güncelleyin
    }
  }, [i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <SimpleReactLightbox>
      <BrowserRouter>
        {/* <TopBar changeLanguage={changeLanguage} /> */}
        <Header changeLanguage={changeLanguage} />
        <CustomRoutes changeLanguage={changeLanguage} />
        <Footer changeLanguage={changeLanguage} />
      </BrowserRouter>
    </SimpleReactLightbox>
  );
}

export default App;
